import {
  BulkAdapterInteface,
  BulkInput,
  BulkUpdateResponse,
  ListBulkOperationsInput,
} from 'src/adapter/BulkAdapterInterface';
import { BulkOperationGetAttributes } from 'src/models/BulkOperationModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
import { exportFile } from 'quasar';
export class AxiosBulkAdapter implements BulkAdapterInteface {
  async bulkUpdateAccountsDryRun(
    input: BulkInput
  ): Promise<BulkUpdateResponse> {
    try {
      const res = await api.post('/bulk/accounts/dryrun', {
        path: input.path,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async bulkUpdateAccounts(input: BulkInput): Promise<BulkUpdateResponse> {
    try {
      const res = await api.post('/bulk/accounts', {
        path: input.path,
      });
      console.log(res.data);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async bulkUpdateResourcesDryRun(
    input: BulkInput
  ): Promise<BulkUpdateResponse> {
    try {
      const res = await api.post('/bulk/resources/dryrun', {
        path: input.path,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async bulkUpdateResources(input: BulkInput): Promise<BulkUpdateResponse> {
    try {
      const res = await api.post('/bulk/resources', {
        path: input.path,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async downloadAccounts(): Promise<boolean> {
    try {
      await api
        .get('/download/csv/accounts', { responseType: 'blob' })
        .then((response) => {
          const status = exportFile('accounts.csv', response.data, 'text/csv');
          if (status === true) {
            console.log('success');
            return true;
          }
          console.log('failed', status);
          return false;
        });
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
    return false;
  }
  async downloadResources(): Promise<boolean> {
    try {
      await api
        .get('/download/csv/resources', { responseType: 'blob' })
        .then((response) => {
          const status = exportFile('resources.csv', response.data, 'text/csv');
          if (status === true) {
            console.log('success');
            return true;
          }
          console.log('failed', status);
          return false;
        });
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
    return false;
  }
  async listBulkOperations(
    conditions?: ListBulkOperationsInput
  ): Promise<{ total: number; data: BulkOperationGetAttributes[] }> {
    try {
      const res = await api.get('/bulk/operations', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
